import * as qiniu from 'qiniu-js'
import dayjs from 'dayjs'

// 七牛上传文件
export const uploadImage = (file, type = '') => {
  return new Promise((resolve) => {
    const qnInfo = JSON.parse(localStorage.getItem('qn_token') || '{}')
    const { host, qntoken } = qnInfo
    const date = dayjs().format('YYYY_MM_DD')
    const time = dayjs().valueOf()
    const random = Math.round(Math.random() * time)
    const key = `${type}/${date}/${time}_${random}_${file.name}`
    const putExtra = {
      fname: file.name,
      mimeType: file.type || null
    }
    const config = {
      useCdnDomain: true, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
      region: null, // 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
      domain: host, // 配置好的七牛云域名  如   https://cdn.qniyun.com/
      chunkSize: 100, // 每个分片的大小，单位mb，默认值3
      forceDirect: true // 直传还是断点续传方式，true为直传
    }
    const observable = qiniu.upload(
      file,
      key,
      qntoken,
      putExtra,
      config
    )
    observable.subscribe({
      error: () => {
        // 上传错误后触发
        resolve({ code: 204, msg: 'upload_Fail' })
      },
      complete: (result) => {
        resolve({ code: 200, data: `${host}${result.key}`, msg: 'complete' })
      }
    })
  })
}

// 读写 localStorage
export const getStorage = (key = '', type = 'string', defaultValue = '') => {
  switch (type) {
    case 'string': {
      defaultValue = ''
      break
    }
    case 'object': {
      defaultValue = '{}'
      break
    }
    case 'array': {
      defaultValue = '[]'
      break
    }
  }
  const data = localStorage.getItem(key) || defaultValue
  if (type === 'object' || type === 'array') {
    return JSON.parse(data)
  } else {
    return data
  }
}
export const setStorage = (key, value) => {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  localStorage.setItem(key, value)
}
